import { useEffect, useState } from "react";
import { X } from "lucide-react";

const STORAGE_KEY = "infinagon_cookie_consent_v1";

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => {
      try {
        const v = localStorage.getItem(STORAGE_KEY);
        if (!v) setVisible(true);
      } catch (_) {
        setVisible(true);
      }
    }, 800);
    return () => clearTimeout(t);
  }, []);

  const persist = (choice) => {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ choice, ts: new Date().toISOString() })
      );
    } catch (_) {}
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:max-w-lg z-[60] bg-black text-white border-2 border-white shadow-2xl"
    >
      <div className="p-5 md:p-6">
        <div className="flex items-start justify-between gap-4 mb-3">
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-white/60 m-0">
            Cookies / Privacy
          </p>
          <button
            data-testid="cookie-close"
            aria-label="Dismiss"
            onClick={() => persist("dismissed")}
            className="text-white/60 hover:text-white -mt-1 -mr-1 p-1"
          >
            <X size={16} />
          </button>
        </div>
        <p className="text-sm leading-relaxed text-white/85 m-0">
          We use cookies to keep the site running smoothly and to understand how
          visitors interact with it. No tracking sold, no funny business.
        </p>
        <div className="mt-5 flex flex-col sm:flex-row gap-3">
          <button
            data-testid="cookie-accept"
            onClick={() => persist("accepted")}
            className="font-mono text-[11px] tracking-[0.25em] uppercase bg-white text-black px-5 py-3 border-2 border-white hover:bg-black hover:text-white transition-colors"
          >
            Accept
          </button>
          <button
            data-testid="cookie-reject"
            onClick={() => persist("rejected")}
            className="font-mono text-[11px] tracking-[0.25em] uppercase bg-transparent text-white px-5 py-3 border-2 border-white/40 hover:border-white transition-colors"
          >
            Essential Only
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
